module.exports = __webpack_public_path__ + "static/media/wtGroupsImg.bba6e3bf.svg";